import React from 'react';
import PropTypes from 'prop-types';
import accounting from 'accounting';

const Amount = ({ data, precision }) => {

  if (precision == null){
    precision = 2;
  }

  let num = accounting.formatNumber(data, precision, ".", ",");

  let minusStyle = {    
  };
 
  if (data < 0){
    minusStyle = {
      color : '#ff0000'
    };
  }

  return (
    <span style={minusStyle} >{num}</span>
  );
};

Amount.propTypes = {
  data: PropTypes.number,
  precision : PropTypes.number
};

export default Amount;



// WEBPACK FOOTER //
// ./src/components/Display/Amount.js